export default __webpack_public_path__ + "static/media/linkedin.27f69bed.svg";